// Feature Configurations
import administration from '../../Features/Administration/administrationConfiguration';
import businessComplianceHub from '../../Features/Business/businessComplianceHubConfiguration';
import business from '../../Features/Business/businessConfiguration';
import communications from '../../Features/Communications/communicationsConfiguration';
import directory from '../../Features/Directory/directoryConfiguration';
import documents from '../../Features/Documents/documentsConfiguration';
import invoices from '../../Features/Invoices/invoicesConfiguration';
import requests from '../../Features/Requests/requestsConfiguration';
import sales from '../../Features/Sales/salesConfiguration';

// Order determines navigation order
const tenantFeatures = [
    invoices,
    documents,
    requests,
    sales,
    communications,
    businessComplianceHub,
    business,
    directory,
    administration,
];

export default tenantFeatures;
